// Races To Watch buttons
filterSelection('all');
function filterSelection(c, id) {
  var x, i;

  // Need to differentiate between sections with ads in between like the Texas House and U.S. House and ones with not

  if (id == 'texas-house' || id == 'us-house') {
    x = document.querySelectorAll(
      '#' +
        String(id) +
        ' div.contests div.office__contests div.contest-group div.seat__contests-double >  .seat'
    );
  } else {
    x = document.querySelectorAll(
      '#' +
        String(id) +
        ' div.contests div.office__contests.seat__contests-double >  .seat'
    );
  }

  // Add the "show" class (display:block) to the filtered elements, and remove the "show" class from the elements that are not selected
  for (i = 0; i < x.length; i++) {
    if (c == 'all') {
      w3RemoveClass(x[i], 'remove');
    } else {
      w3RemoveClass(x[i], 'remove');
      if (x[i].getElementsByClassName('get__flag').length == 0)
        w3AddClass(x[i], 'remove');
    }
  }
}

// Show filtered elements
function w3AddClass(element, name) {
  var i, arr1, arr2;
  arr1 = element.className.split(' ');
  arr2 = name.split(' ');
  for (i = 0; i < arr2.length; i++) {
    if (arr1.indexOf(arr2[i]) == -1) {
      element.className += ' ' + arr2[i];
    }
  }
}

// Hide elements that are not selected
function w3RemoveClass(element, name) {
  var i, arr1, arr2;
  arr1 = element.className.split(' ');
  arr2 = name.split(' ');
  for (i = 0; i < arr2.length; i++) {
    while (arr1.indexOf(arr2[i]) > -1) {
      arr1.splice(arr1.indexOf(arr2[i]), 1);
    }
  }
  element.className = arr1.join(' ');
}

// Add active class to the current control button (highlight it)
var btnContainer = document.querySelectorAll('#btnGroup');

for (var i = 0; i < btnContainer.length; i++) {
  var btns = btnContainer[i].getElementsByClassName('race_to_watch_button');

  for (var t = 0; t < btns.length; t++) {
    btns[t].addEventListener('click', function(event) {
      var path =
        event.path ||
        (event.composedPath && event.composedPath()) ||
        composedPath(event.target);

      var currentParent = document.querySelector(
        '#btnGroup.' + path[1].className
      );
      var current = currentParent.getElementsByClassName('active');
      current[0].className = current[0].className.replace(' active', '');
      this.className += ' active';

      filterSelection(this.value, path[2].id);
    });
  }
}
